import { onPageLoaded } from "@assets/js/imaios-global/imaios-global";

/**
 * @template Func
 * @param {Func} func
 * @param {number} delay
 * @returns {Func}
 */
function debounce(func, delay) {
	let timeout = null;
	return (...args) => {
		const next = () => func(...args);
		clearTimeout(timeout);
		timeout = setTimeout(next, delay);
	};
}

/**
 * @param {string} inputValue
 * @param {HTMLDivElement} dropdown
 * @param {string[]} suggestionList
 * @param {(event: Event, suggestion: string) => void} onClick callback for the onClick handler of the suggestion items
 * @return void
 */
function addDropdownItems(inputValue, dropdown, suggestionList, onClick) {
	dropdown.innerHTML = '';
	suggestionList.forEach(suggestionItem => {
		const element = document.createElement('button');
		element.classList.add('dropdown-item', 'search-case__suggestion-item');

		const startIndex = suggestionItem.indexOf(inputValue);

		if (startIndex !== -1) {
			element.innerHTML = `${suggestionItem.slice(0, startIndex)}<span class="search-case__highlight">${suggestionItem.slice(startIndex, startIndex + inputValue.length)}</span>${suggestionItem.slice(startIndex + inputValue.length)}`;
		}
		else {
			element.innerHTML = suggestionItem;
		}
		element.addEventListener('click', event => {
			onClick(event, suggestionItem);
			toggleDropdown(dropdown, false);
		});
		dropdown.appendChild(element);
	})
}

/**
 * @todo add support for aria-expanded on the input
 *
 * @param {HTMLDivElement} dropdown
 * @param {boolean} [forceVisible]
 */
function toggleDropdown(dropdown, forceVisible) {
	dropdown.classList.toggle('d-block', forceVisible);
}

/**
 *
 * @param {HTMLInputElement} input
 * @param {Event} event
 * @return void
 */
function searchValueAutocomplete(input, event) {
	const id = input.id.replace('search-field__', '');
	const dropdown = document.getElementById(`search-suggestion__${id}`);

	if (input.value === '') {
		toggleDropdown(dropdown, false);
		return;
	}
	const url = imaios
		.get('imaios-search-autocomplete')
		.replace('__query__', input.value)
		.replace('__locale__', input.getAttribute('data-lang'));
	console.log(url);
	imaios
		.fetch(
			url,
			{ method: 'GET' }
		)
		.then(response => {
			if (response.ok) {
				return response.json();
			}
			else {
				throw response;
			}
		})
		.then( /** @param {string[]} payload*/ (payload) => {
			// hide suggestions when no results fond (iso legacy)
			if (payload.length === 0) {
				toggleDropdown(dropdown, false);
				return;
			}

			addDropdownItems(input.value, dropdown, payload, (event, value) => {
				input.value = value;
			});

			toggleDropdown(dropdown, true);

		});
}

onPageLoaded(function () {
	const debouncedSearch = debounce(searchValueAutocomplete, 150);
	const containers = Array.from(document.querySelectorAll('.search-case'));
	const dropdowns = Array.from(document.querySelectorAll('.search-case__suggestion'));

	document
		.querySelectorAll("[data-id='search-field']")
		.forEach(input => {
			input.addEventListener('input', event => debouncedSearch(input, event));
			input.addEventListener('keydown', (event) => {
				if(event.key === "Escape") {
					dropdowns.forEach(dropdown => toggleDropdown(dropdown, false))
				}
			})
		});

	document.body.addEventListener('click', event => {
		// Note: composedPath is not supported on IE and Edge, more information here:
		//       https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
		//       In the meanwhile, we are using el.contains for those browsers, not
		//       the ideal solution, but using IE or EDGE is not ideal either.
		const path = event.path || (event.composedPath && event.composedPath());
		const isClickOutside = path
			? path.indexOf(containers) < 0
			: !containers.includes(event.target)
		if(isClickOutside) {
			dropdowns.forEach(dropdown => toggleDropdown(dropdown, false));
		}
	})

});
